export enum MedicalPrescriptionStatus {
  Undefined = 0,
  Created = 1,
  Accepted = 2,
  Rejected = 3,
  Completed = 4
}

export const REMOVE_BLEND_ID = -1;
